/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProjectPortfolioReportTitleBar_viewer$ref: FragmentReference;
declare export opaque type ProjectPortfolioReportTitleBar_viewer$fragmentType: ProjectPortfolioReportTitleBar_viewer$ref;
export type ProjectPortfolioReportTitleBar_viewer = {|
  +email: ?string,
  +actualPersonId: ?string,
  +$refType: ProjectPortfolioReportTitleBar_viewer$ref,
|};
export type ProjectPortfolioReportTitleBar_viewer$data = ProjectPortfolioReportTitleBar_viewer;
export type ProjectPortfolioReportTitleBar_viewer$key = {
  +$data?: ProjectPortfolioReportTitleBar_viewer$data,
  +$fragmentRefs: ProjectPortfolioReportTitleBar_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPortfolioReportTitleBar_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '9451cf005dc5e6c5763601e15212603c';

module.exports = node;
